export const getSearchHrefUrl = (isMobileDevice = false) => !isMobileDevice ? `/search` : '/mobileAdFilter'
